import { render, staticRenderFns } from "./FormSubmissionList.vue?vue&type=template&id=4c535362&scoped=true&"
import script from "./FormSubmissionList.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmissionList.vue?vue&type=style&index=0&id=4c535362&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c535362",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDataTable,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c535362')) {
      api.createRecord('4c535362', component.options)
    } else {
      api.reload('4c535362', component.options)
    }
    module.hot.accept("./FormSubmissionList.vue?vue&type=template&id=4c535362&scoped=true&", function () {
      api.rerender('4c535362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/forms/FormSubmissionList.vue"
export default component.exports